import {List, ListItemAvatar, ListItemText} from "@mui/material";
import SteddiContainer from "../../General/SteddiContainer";
import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import {Calculator, Plug, ReceiptText} from "lucide-react";
import DynamicListItem from "../../General/DynamicListItem";
import SectionHeader from "../../General/SectionHeader";
import Graph from "../../../images/Graph.png";

export default function CalculationInfoPage() {

  return (
    <>
      <Grid2 container spacing={3}>
        <Grid2 xs={12}>
          <SteddiContainer>
            <Grid2 container>
              <Grid2 xs={12} md={6}>
                <List sx={{pb: 0}} className="no-left-pad-list">
                  <DynamicListItem>
                    <ListItemAvatar>
                      <Plug/>
                    </ListItemAvatar>
                    <ListItemText>
                      Fordi du betaler et forutsigbart beløp til Steddi, vil det være forskjell på det du har betalt inn og det du faktisk har brukt på strøm og nettleie. Denne forskjellen vises på
                      saldoen din.
                    </ListItemText>
                  </DynamicListItem>
                  <DynamicListItem>
                    <ListItemAvatar>
                      <Calculator/>
                    </ListItemAvatar>
                    <ListItemText>
                      Saldoen kan være både positiv og negativ – og den vil endre seg fra måned til måned. For å unngå at saldoen går for mye i minus eller pluss, kan månedsbeløpet ditt bli beregnet på
                      nytt. Da blir du varslet om dette.
                    </ListItemText>
                  </DynamicListItem>
                  <DynamicListItem>
                    <ListItemAvatar>
                      <ReceiptText/>
                    </ListItemAvatar>
                    <ListItemText>
                      Etter at du har fått din første faktura fra Steddi, kan du når som helst følge med på saldoen din inne på Min side hos strømleverandøren din.
                    </ListItemText>
                  </DynamicListItem>
                </List>
              </Grid2>
              <Grid2 xs={12} md={6} sx={{textAlign: "center", mt: 2}}>
                <img src={Graph} alt="Steddi example graph"/>
              </Grid2>
            </Grid2>
          </SteddiContainer>
        </Grid2>
      </Grid2>
    </>
  )
}